import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=4e721b2a"
import script from "./Supplier.vue?vue&type=script&lang=js"
export * from "./Supplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e721b2a')) {
      api.createRecord('4e721b2a', component.options)
    } else {
      api.reload('4e721b2a', component.options)
    }
    module.hot.accept("./Supplier.vue?vue&type=template&id=4e721b2a", function () {
      api.rerender('4e721b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/payments/Supplier.vue"
export default component.exports